<script>
export let items;
export let selected = {};
export let placeholder = 'Select...';
export let key;
export let icon;
if(key) selected = items.find(i => i.key == key);
if(!selected) selected = items[0];

let filter = '';
let open = false;
let node;
let focus;
import { createEventDispatcher } from 'svelte';
import { traverseUp } from './lib';

const dispatch = createEventDispatcher();

function listener(e) {
	if(!traverseUp(e.target, node)) {
		filter = '';
		open = false;
	}
};
$: if(open) {
	document.addEventListener('click', listener);
}else{
	document.removeEventListener('click', listener);
}

$: if(filter.length > 0 && !open) open = true;

$: if(selected) key = selected.key;

function select(item) {
	selected = item;
	filter = '';
	dispatch('select', selected);
}
function toggle(){
	open = !open;
}
</script>

<div class="Dropdown" tabindex="0" on:click={toggle} class:open class:focus class:filter={filter.length > 0} bind:this={node}>
	<input type="text" placeholder={(selected.value || filter)?"":placeholder} bind:value={filter} size="16" on:focus={() => focus=true} on:blur={() => focus=false}  />
	<div class="Dropdown-selectedItem" data-icon={selected.icon || icon}>{selected.shortValue || selected.value || ''}</div>
	<div class="Dropdown-list UI List Selector">
		{#each items as item, index (item.key)}
			{#if !filter || item.value.toLowerCase().indexOf(filter.toLowerCase()) > -1}
			<i class="UI SelectorElement" class:s={item == selected} on:click={() => select(item)} data-icon={item.icon || "undefined"}>{item.value}</i>
			{/if}
		{/each}
	</div>
</div>

<style>
.Dropdown {
	height:2.5em;
	display:inline-flex;
	position:relative;
	border:1px solid rgba(255,255,255,.2);
	border-radius:4px;
	background:rgba(0,0,0,.2);
	color:#fff;
	align-items:stretch;
	align-self:center;
	cursor:pointer;
	margin-right:1em;
	min-width: 5em;
}
.Dropdown:hover {
	border-color:rgba(255,255,255,.3)
}
.Dropdown:after {
	content:"\e90c";
	position:absolute;
	font-family:iconfont;
	height:100%;
	right:0;
	padding-right:.7em;
	padding-left:.7em;
	display:flex;
	align-items:center
}
.Dropdown input {
	position:absolute;
	top:0;
	left:0;
	right:0;
	width:100%;
	min-width:100%;
	border:none;
	height:100%;
	background:0 0;
	color:#fff;
	padding-left:.7em;
	font-size:1em;
	box-sizing:border-box;
	outline:none;
	margin:0;
}
.Dropdown-selectedItem {
	display:flex;
	justify-content:center;
	align-items:center;
	padding:0 2.3em 0 .7em;
	pointer-events:none;
	transition: opacity .15s ease
}
.Dropdown.focus .Dropdown-selectedItem {
	opacity:.6;
}
.Dropdown.filter .Dropdown-selectedItem {
	opacity: 0;
}
.Dropdown-selectedItem[data-icon]:before,
.Dropdown-list>.UI[data-icon]:before {
	align-self:center;
	padding-right:.7em
}
.Dropdown-list {
	position:absolute;
	top:100%;
	flex-direction:column;
	background:#131c29;
	min-width:100%;
	z-index:100;
	display: none;
	overflow-x: auto;
	max-height: 70vh;
}
.open .Dropdown-list {
	display: inline-flex;
}
.Dropdown-list .s {
	background:rgba(255,255,255,.1)
}
.Dropdown-list .s:before {
	opacity: 1 !important;
}
.Dropdown-list>.UI {
	padding:.5em .7em;
	font-style:normal;
	cursor:pointer;
	display:flex;
	border-bottom:1px solid rgba(255,255,255,.1)
}
.Dropdown-list>.UI:hover {
	background:rgba(255,255,255,.2)
}
.Dropdown-list>.UI:before {
	opacity:0
}
.Dropdown-list>.UI.s:before {
	content:"\e914";
	opacity:1
}
:global([data-icon="undefined"]:before) {
	content: "\e914";
	opacity: 0;
}
</style>
